// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

interface CallQueuerTask {
  id: number | null;
  func: () => void;
}

export default class CallQueuer {
  batch!: number;
  tasks!: Array<CallQueuerTask>;
  id!: number | null;

  constructor(batch: number) {
    if (batch == null) {
      batch = 3;
    }
    this.batch = batch;
    this.tasks = [];
    this.id = null;
  }

  process(n: number): void {
    const tasks = this.tasks.splice(0, n);
    if (tasks.length > 0) {
      tasks.forEach((task) => {
        task.func();
      });
    } else {
      this.stop();
    }
  }

  resume(): void {
    if (this.id == null) {
      // @ts-expect-error TS is looking at Node's setInterval instead of the native setInterval
      this.id = setInterval(this.process.bind(this), 17, this.batch);
    }
  }

  stop(): void {
    if (this.id != null) {
      clearInterval(this.id);
      this.id = null;
    }
  }

  add(id: number | null, f: () => void): void {
    this.remove(id); // Remove a task if it already exists in the queue for a particular id.
    this.tasks.push({id, func: f});
  }

  stack(id: number | null, f: () => void): void {
    this.remove(id);
    this.tasks.unshift({id, func: f});
  }

  remove(id: number | null): CallQueuerTask | void {
    if (id == null) {
      return;
    }
    const i = this.find(id);
    if (i > -1) {
      return this.tasks.splice(i, 1)[0];
    }
  }

  purge(): void {
    this.tasks = [];
    this.stop();
  }

  find(id: number | null): number {
    // eslint-disable-next-line no-restricted-syntax
    return _.indexOf(
      // eslint-disable-next-line no-restricted-syntax
      _.map(this.tasks, (task) => task.id),
      id
    );
  }

  // Process desired task next.
  restack(id: number | null): void {
    const task = this.remove(id);
    if (task != null) {
      this.stack(task.id, task.func);
    }
  }
}
